import { type ReactNode } from "react";

export function AdminSettingsSectionShell({
  title,
  description,
  actions,
  footer,
  children,
}: {
  title: string;
  description: string;
  actions?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section className="rounded-2xl border border-border/60 bg-card px-5 py-5 shadow-sm sm:px-7 sm:py-6">
      <header className="mb-5 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div className="min-w-0">
          <h2
            className="text-2xl font-semibold leading-tight tracking-tight text-foreground"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            {title}
          </h2>
          <p className="mt-1.5 max-w-2xl text-sm leading-relaxed text-muted-foreground">
            {description}
          </p>
        </div>
        {actions && <div className="shrink-0">{actions}</div>}
      </header>
      <div>{children}</div>
      {footer && (
        <div className="mt-6 flex justify-end border-t border-border/60 pt-5">{footer}</div>
      )}
    </section>
  );
}
